import ActiveItemStore from '@stores/paginated-hierarchy-items/ActiveItemStore'
import { action, observable } from 'mobx'

export default class ActiveCellItemStore extends ActiveItemStore {
  @observable colIndex = -1

  @action
  setColIndex = (index: number) => {
    this.colIndex = index
  }

  @action
  setRowAndColIndex = (rowIndex: number, colIndex: number) => {
    this.setIndex(rowIndex)
    this.setColIndex(colIndex)
  }
}
